// src/ui/appLauncher.js
// Waffle (app launcher) estilo Microsoft 365: botao ph-dots-nine no topo que abre um
// popover com atalhos para os OUTROS sistemas do Rafael (cada um em nova aba).
// Reusavel: a lista vem de src/config/sistemas.js (so esse arquivo muda por projeto).
import { el } from '../lib/dom.js';
import { SISTEMAS } from '../config/sistemas.js';

export function appLauncher() {
  const menu = el('div', { class: 'waffle__menu', style: 'display:none' });
  const btn = el('button', { class: 'waffle__btn', title: 'Meus sistemas', 'aria-label': 'Meus sistemas', 'aria-haspopup': 'true' }, [el('i', { class: 'ph ph-dots-nine' })]);
  const wrap = el('div', { class: 'waffle' }, [btn, menu]);

  function fechar() { menu.style.display = 'none'; document.removeEventListener('click', aoFora); }
  function aoFora(e) { if (!wrap.contains(e.target)) fechar(); }
  function pintar() {
    menu.innerHTML = '';
    menu.append(el('div', { class: 'waffle__tit', text: 'Meus sistemas' }));
    const grade = el('div', { class: 'waffle__grade' });
    SISTEMAS.forEach((s) => {
      const tile = s.atual
        ? el('div', { class: 'waffle__item waffle__item--atual', title: 'Voce esta aqui' })
        : el('a', { class: 'waffle__item', href: s.url, target: '_blank', rel: 'noopener noreferrer', title: s.descricao || s.nome });
      const filhos = [
        el('div', { class: 'waffle__ic', style: `background:${s.cor || '#5f5e5a'}` }, [el('i', { class: 'ph ' + (s.icone || 'ph-app-window') })]),
        el('div', { class: 'waffle__nome', text: s.nome }),
      ];
      if (s.atual) filhos.push(el('div', { class: 'waffle__aqui', text: 'voce esta aqui' }));
      tile.append(...filhos);
      grade.append(tile);
    });
    menu.append(grade);
  }
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    if (menu.style.display === 'none') { pintar(); menu.style.display = ''; document.addEventListener('click', aoFora); }
    else fechar();
  });
  return wrap;
}